// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { useEffect, useState } from 'react';
import '../../styles/AvatarMenu.css';
import { useAuthContext } from '@asgardeo/auth-react';
import LogoutIcon from '@mui/icons-material/Logout';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import Avatar from '@mui/material/Avatar';
import { useGetApi } from '../../data/hooks/api';
import { RESOURCE_SERVER_URLS } from '../../data/configs/spl-config';
import * as Types from "../../data/utils/types";
import CircularLoading from '../Loading';

export default function AvatarMenu() {
    const { state, signOut } = useAuthContext();
    const [isInProgress, setIsInProgress] = useState(false);
    const [profile, setProfile] = useState("");
    const [dispalyName, setDisplayName] = useState("");

    const apiUrl = RESOURCE_SERVER_URLS[0] + `/user-info`;
    const { data, getApiData } = useGetApi<Types.UserInfo>({ url: apiUrl, headers: { accept: "application/json" } });

    useEffect(() => {
        getApiData();
    }, []);

    useEffect(() => {
        if (data) {
            setProfile(data.employeeThumbnail ? data.employeeThumbnail : "");
            setDisplayName(data.firstName + " " + data.lastName);
        }
    }, [data]);

    const logoutHandler = () => {
        setIsInProgress(true);
        signOut();
    };

    return (
        <>
            <CircularLoading openLoading={isInProgress} />
            <div className="dropdown">
                <button className="avatar-button"
                    type="button" data-bs-toggle="dropdown" aria-expanded="false" disabled={isInProgress}>
                    <div className="user-avatar">
                        <Avatar src={profile} sx={{ width: 30, height: 30 }} />
                    </div>
                    <div className="title-class">{dispalyName}</div>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                    <List sx={{ padding: 0, width: '100%', maxWidth: 360, bgcolor: 'background.color' }}>
                        <ListItem alignItems="flex-start">
                            <ListItemAvatar>
                                <Avatar src={profile} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={dispalyName}
                                secondary={state.email}
                            />
                        </ListItem>
                        <Divider />
                        <ListItemButton onClick={logoutHandler}>
                            <LogoutIcon sx={{ paddingRight: 1 }} />
                            <ListItemText primary=" Logout" />
                        </ListItemButton>
                    </List>
                </ul>
            </div>
        </>
    );
}
